import { toast } from "react-toastify";
import authService from "../../api/authService";
import {
    LOAD_SESSIONS,
    LOADING_SESSIONS,
    LOADING_CLOSE_SESSION,
    LOADING_CLOSE_ALL_SESSIONS,
} from "./actionTypes";

// Action Creators
const loadSessions = (sessions) => {
    return {
        type: LOAD_SESSIONS,
        payload: { sessions }
    };
};

const loadingSessions = (loadingSessions) => {
    return {
        type: LOADING_SESSIONS,
        payload: { loadingSessions }
    };
};

const loadingCloseSession = (loadingCloseSession) => {
    return {
        type: LOADING_CLOSE_SESSION,
        payload: { loadingCloseSession }
    };
};

const loadingCloseAllSessions = (loadingCloseAllSessions) => {
    return {
        type: LOADING_CLOSE_ALL_SESSIONS,
        payload: { loadingCloseAllSessions }
    };
};

// Thunk Actions
export const getSessions = () => async (dispatch) => {
    try {
        dispatch(loadingSessions(true));
        const response = await authService.getAllSessions();
        dispatch(loadSessions(response));
        dispatch(loadingSessions(false));
    } catch (error) {
        dispatch(loadingSessions(false));
        toast.error("Error al cargar las sesiones");
        throw error;
    }
};

export const closeSession = (sessionData) => async (dispatch) => {
    try {
        dispatch(loadingCloseSession(true));
        await authService.closeSession(sessionData);
        // Recargar las sesiones después de cerrar una
        const response = await authService.getAllSessions();
        dispatch(loadSessions(response));
        dispatch(loadingCloseSession(false));
        toast.success("Sesión cerrada exitosamente");
    } catch (error) {
        dispatch(loadingCloseSession(false));
        toast.error("Error al cerrar la sesión");
        throw error;
    }
};

export const closeAllSessions = (sessionData) => async (dispatch) => {
    try {
        dispatch(loadingCloseAllSessions(true));
        await authService.closeAllSessions(sessionData);
        // Recargar las sesiones después de cerrar todas
        const response = await authService.getAllSessions();
        dispatch(loadSessions(response));
        dispatch(loadingCloseAllSessions(false));
        toast.success("Todas las sesiones han sido cerradas");
    } catch (error) {
        dispatch(loadingCloseAllSessions(false));
        toast.error("Error al cerrar todas las sesiones");
        throw error;
    }
};